module.exports = __webpack_public_path__ + "img/googleplay.de274080.svg";